<template>
  <section class="authentication-form">
    <div>
      <h2 class="title text-center">RESET YOUR<span> PASSWORD</span></h2>
      <div class="card">
        <form class="theme-form" @submit.prevent="forget">
          <div class="form-group mt-2">
            <h6 class="mt-0 mb-3">Enter your email:</h6>
            <div class="form-row">
              <div class="col-12">
                <input
                  v-model="input.email"
                  type="email"
                  class="form-control"
                  placeholder="someone@someone.com"
                />
              </div>
              <div class="col-12 mt-4">
                <button
                  type="submit"
                  class="btn btn-custom btn-block theme-color"
                  :disabled="sending"
                >
                  {{ sending ? 'Sending...' : 'Send' }}
                </button>
              </div>
            </div>
          </div>
          <p v-if="error" class="text-danger" role="alert">
            {{ error }}
          </p>
        </form>
      </div>
    </div>
  </section>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import $ from 'jquery'
export default {
  name: 'ForgetPassword',
  data() {
    return {
      sending: false,
      error: '',
      input: {
        email: null,
      },
    }
  },
  mounted: function () {
    $('.navbar').addClass('darkHeader')
  },
  methods: {
    async forget() {
      if (this.sending) return
      this.sending = true
      this.error = ''
      try {
        await this.axios.post(`${process.env.ROOT_API}/user/forgot/password`, {
          email: this.input.email,
        })
        this.$router.push({ name: 'AfterForgetPassword' })
      } catch (error) {
        this.error = 'We could not send your reset email. Please check your address and try again.'
      } finally {
        this.sending = false
      }
    },
  },
}
</script>
<style scoped>
.form-control {
  background-color: #d6fff1 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/forget_password.vue